import script from "./ImageDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageDetail.vue?vue&type=script&setup=true&lang=js"

import "./ImageDetail.vue?vue&type=style&index=0&id=85e3f0a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85e3f0a8"]])

export default __exports__